import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterComponent from '@/components/RouterComponent.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: () => import('../views/main/Start.vue'),
    children: [
      {
        path: 'login',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import('../views/Login.vue'),
      },
      {
        path: 'main',
        component: () => import('../views/main/Main.vue'),
        children: [
          {
            path: 'dashboard',
            component: () => import('../views/main/Dashboard.vue'),
          },
          {
            path: 'profile',
            component: RouterComponent,
            redirect: 'profile/view',
            children: [
              {
                path: 'view',
                component: () => import('../views/main/profile/UserProfile.vue'),
              },
              {
                path: 'edit',
                component: () => import('../views/main/profile/UserProfileEdit.vue'),
              },
              {
                path: 'password',
                component: () => import('../views/main/profile/UserProfileEditPassword.vue'),
              },
            ],
          },
          {
            path: 'admin',
            component: () => import('../views/main/admin/Admin.vue'),
            redirect: 'admin/users/all',
            children: [
              // {
              //   path: 'users',
              //   redirect: 'users/all',
              // },
              // {
              //   path: 'users/all',
              //   component: () => import('../views/main/admin/AdminUsers.vue'),
              // },
              // {
              //   path: 'users/edit/:id',
              //   name: 'main-admin-users-edit',
              //   component: () => import('../views/main/admin/EditUser.vue'),
              // },
              // {
              //   path: 'users/create',
              //   name: 'main-admin-users-create',
              //   component: () => import('../views/main/admin/CreateUser.vue'),
              // },
              {
                path: 'services',
                redirect: 'services/all',
              },
              {
                path: 'services/all',
                component: () => import('../views/main/service/Services.vue'),
              },
              {
                path: 'services/create',
                name: 'main-admin-services-create',
                component: () => import('../views/main/service/CreateService.vue'),
              },
              {
                path: 'services/edit/:id',
                name: 'main-admin-services-edit',
                component: () => import('../views/main/service/EditService.vue'),
              },
              {
                path: 'senders',
                redirect: 'senders/all',
              },
              {
                path: 'senders/all',
                component: () => import('../views/main/sender/Senders.vue'),
              },
              {
                path: 'senders/create',
                name: 'main-admin-senders-create',
                component: () => import('../views/main/sender/CreateSender.vue'),
              },
              {
                path: 'senders/edit/:id',
                name: 'main-admin-senders-edit',
                component: () => import('../views/main/sender/EditSender.vue'),
              },
              {
                path: 'templates',
                redirect: 'templates/all',
              },
              {
                path: 'templates/all',
                component: () => import('../views/main/template/Templates.vue'),
              },
              {
                path: 'templates/create',
                name: 'main-admin-templates-create',
                component: () => import('../views/main/template/CreateTemplate.vue'),
              },
              {
                path: 'templates/edit/:id',
                name: 'main-admin-templates-edit',
                component: () => import('../views/main/template/EditTemplate.vue'),
              },
              {
                path: 'proxy_errors',
                redirect: 'proxy_errors/all',
              },
              {
                path: 'proxy_errors/all',
                component: () => import('../views/main/proxy_error/ProxyErrors.vue'),
              },
              {
                path: 'proxy_errors/create',
                name: 'main-admin-proxy_errors-create',
                component: () => import('../views/main/proxy_error/CreateProxyError.vue'),
              },
              {
                path: 'proxy_errors/edit/:id',
                name: 'main-admin-proxy_errors-edit',
                component: () => import('../views/main/proxy_error/EditProxyError.vue'),
              },
              {
                path: 'ban_policies',
                redirect: 'ban_policies/all',
              },
              {
                path: 'ban_policies/all',
                component: () => import('../views/main/ban_policy/BanPolicies.vue'),
              },
              {
                path: 'ban_policies/create',
                name: 'main-admin-ban_policies-create',
                component: () => import('../views/main/ban_policy/CreateBanPolicy.vue'),
              },
              {
                path: 'ban_policies/edit/:id',
                name: 'main-admin-ban_policies-edit',
                component: () => import('../views/main/ban_policy/EditBanPolicy.vue'),
              },
              {
                path: 'proxy_user_bans',
                redirect: 'proxy_user_bans/all',
              },
              {
                path: 'proxy_user_bans/all',
                component: () => import('../views/main/proxy_user_ban/ProxyUserBans.vue'),
              },
              {
                path: 'proxy_user_bans/create',
                name: 'main-admin-proxy_user_bans-create',
                component: () => import('../views/main/proxy_user_ban/CreateProxyUserBan.vue'),
              },
              {
                path: 'proxy_user_bans/statistics',
                component: () => import('../views/main/proxy_user_ban/Statistics.vue'),
              },
              {
                path: 'priorities',
                redirect: 'priorities/all',
              },
              {
                path: 'priorities/all',
                component: () => import('../views/main/priority/Priorities.vue'),
              },
              {
                path: 'mnos/all',
                component: () => import('../views/main/mno/MNOs.vue'),
              },
              {
                path: 'mnos/:id/masks',
                name: 'main-mno-masks',
                component: () => import('../views/main/mno/MNOMasks.vue'),
              },
              {
                path: 'utilities/check_template_proxy',
                component: () => import('../views/main/utilities/CheckTemplateProxy.vue'),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/*',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
